// Marketplace listings need a title, but users no longer type one: the field asked
// people to invent a headline for an ad whose text they had already written, and a
// half-filled or copy-pasted title is worse than a derived one.
//
// Shared by every surface that can create a listing — the post editor, the
// convert-to-marketplace modal and the onboarding wizard — so a listing gets the same
// title regardless of which screen made it.
export function buildMarketplaceTitle(mp: any, post?: any): string {
  const m = mp || {}
  const rooms = parseInt(m.bedrooms, 10) || 0
  const postName = String(post?.name || '').trim()
  switch (m.listing_type) {
    case 'home_rent':
      return rooms > 0 ? `דירת ${rooms} חדרים להשכרה` : 'דירה להשכרה'
    case 'home_sale':
      return rooms > 0 ? `דירת ${rooms} חדרים למכירה` : 'דירה למכירה'
    case 'vehicle': {
      const parts = [m.vehicle_make, m.vehicle_model].filter(Boolean).join(' ').trim()
      if (parts) return m.vehicle_year ? `${parts} ${m.vehicle_year}` : parts
      return m.vehicle_year ? `רכב שנת ${m.vehicle_year} למכירה` : 'רכב למכירה'
    }
    default:
      return postName || 'פריט למכירה'
  }
}
